






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SiteRole, siteAdminRoleApis, RoleMembers, Employee, Department } from '../../api';
import EmployeeTransfer from '../../components/EmployeeTransfer.vue';
import DepartmentTransfer from '../../components/DepartmentTransfer.vue';

@Component({ components: { EmployeeTransfer, DepartmentTransfer } })
export default class RoleMembersDialog extends Vue {
  @Prop() siteId!: number;
  dialogVisible = false;
  role: SiteRole | null = null;
  members: RoleMembers | null = null;
  listVisible = false;
  loading = true;
  tabValue = 'employees';

  show(role: SiteRole, adminType?: string) {
    this.role = role;
    siteAdminRoleApis.getRoleMembers(this.siteId, role.id).then(members => {
      this.members = members;
      this.loading = false;
    });
    this.dialogVisible = true;
    if (adminType == 'Authorizer') {
      this.listVisible = true;
    }
  }

  async moveInEmployee(employee: Employee) {
    if (this.role) {
      this.members = await siteAdminRoleApis.updateRoleMember({
        siteId: this.siteId,
        roleId: this.role.id,
        checked: true,
        employeeId: employee.id
      });
    }
  }

  async moveOutEmployee(employee: Employee) {
    if (this.role) {
      this.members = await siteAdminRoleApis.updateRoleMember({
        siteId: this.siteId,
        roleId: this.role.id,
        checked: false,
        employeeId: employee.id
      });
    }
  }

  async moveInDepartment(department: Department) {
    if (this.role) {
      this.members = await siteAdminRoleApis.updateRoleMember({
        siteId: this.siteId,
        roleId: this.role.id,
        checked: true,
        departmentId: department.id
      });
    }
  }

  async moveOutDepartment(department: Department) {
    if (this.role) {
      this.members = await siteAdminRoleApis.updateRoleMember({
        siteId: this.siteId,
        roleId: this.role.id,
        checked: false,
        departmentId: department.id
      });
    }
  }

  onClosed() {
    this.role = null;
    this.members = null;
    this.listVisible = false;
    this.loading = true;
    this.tabValue = 'employees';
  }
}
